var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVarianceHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 19.9997C12.0353 19.9997 11.6576 19.6228 11.6575 19.1579L11.6575 6.87665L7.20045 11.3317C6.89689 11.6353 6.41947 11.6589 6.08912 11.402L6.01002 11.3317C5.70646 11.0282 5.68285 10.5507 5.93971 10.2204L6.01002 10.1413L11.9046 4.24676C12.2081 3.94321 12.6855 3.91961 13.0159 4.17645L13.095 4.24676L18.9905 10.1413C19.3189 10.4701 19.3189 11.0029 18.9905 11.3317C18.6869 11.6353 18.2085 11.6589 17.8782 11.402L17.7991 11.3317L13.3421 6.87567L13.3421 19.1579C13.3419 19.6227 12.9651 19.9995 12.5003 19.9997Z",
    fill: "#00AD3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarianceHigh);
export default __webpack_public_path__ + "static/media/VarianceHigh.3e0133aaac4423eed9272a6e0d7aaf46.svg";
export { ForwardRef as ReactComponent };